/**
 * Simple fade-in wrappers.
 * Content is always visible (opacity 1 default). A fadeInUp animation plays
 * on initial mount via the stagger-children rule below. No IntersectionObserver,
 * no re-triggering, no hidden frames — so re-renders never cause blank content.
 */
export default function Reveal({ children, className = '', as: Tag = 'div', ...rest }) {
    return (
        <Tag className={`animate-fade-in-up ${className}`} {...rest}>
            {children}
        </Tag>
    );
}

export function RevealStagger({ children, className = '', as: Tag = 'div', ...rest }) {
    return (
        <Tag className={`stagger-children ${className}`} {...rest}>
            {children}
        </Tag>
    );
}
